import React, { useState } from 'react';
import { Alert } from 'antd';

const EmailForm = () => {
    const [formData, setFormData] = useState({
        email_id: '',
        message: ''
    });
    const [errors, setErrors] = useState({});
    const [status, setStatus] = useState({
        submitting: false,
        success: false,
        error: false,
        message: ''
    });

    const validateEmail = (email) => {
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return re.test(email);
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.email_id.trim()) {
            newErrors.email_id = 'Email is required';
        } else if (!validateEmail(formData.email_id)) {
            newErrors.email_id = 'Please enter a valid email';
        }

        if (!formData.message.trim()) {
            newErrors.message = 'Message cannot be empty';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: ''
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setStatus({ submitting: true, success: false, error: false, message: '' });

        try {
            const response = await fetch('https://quranpoint.skyraantech.com/backend/sendMail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email_id: formData.email_id,
                    message: formData.message
                })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Something went wrong');
            }

            setStatus({
                submitting: false,
                success: true,
                error: false,
                message: 'Message sent successfully!'
            });

            // Reset form after successful submission
            setFormData({ email_id: '', message: '' });

        } catch (error) {
            setStatus({
                submitting: false,
                success: false,
                error: true,
                message: error.message || 'Failed to send message. Please try again.'
            });
        }
    };

    return (
        <div className="email-form-container">
            <form onSubmit={handleSubmit}>
                <div className="mb-4 relative">
                    <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Your message"
                        className={`w-full p-3  rounded-lg resize-none h-24 focus:outline-none focus:ring-2 `} style={{ backgroundColor:"#D8DAD380"}}
                    />
                    {errors.message && (
                        <p className="text-red-500 text-sm mt-1">{errors.message}</p>
                    )}
                </div>

                <div className="relative flex">
                    <input
                        type="email"
                        name="email_id"
                        value={formData.email_id}
                        onChange={handleChange}
                        placeholder="Your email"
                        className={`flex-grow p-3 border rounded-l-lg focus:outline-none focus:ring-2 ${errors.email_id ? 'border-red-500 focus:ring-red-200' : 'borderColor focus:ring-green-200'}`}
                    />
                    <button
                        type="submit"
                        disabled={status.submitting}
                        className="bg-green-500 hover:bg-green-600 text-white font-medium max320:px-2 py-3 px-6 rounded-r-lg transition duration-200"
                    >
                        {status.submitting ? 'Sending...' : 'Send'}
                    </button>
                </div>
                {errors.email_id && (
                    <p className="text-red-500 text-sm mt-1">{errors.email_id}</p>
                )}

                {/* Status Alerts */}
                <div className="mt-4   ">
                    { 
                      status.success 
                    
                    && (
                        <Alert className=' fixed top-[5rem] z-[1000] right-[3rem] '
                            message="Success"
                            description={status.message}
                            type="success"
                            showIcon
                            closable
                        />
                    )}

                    {status.error && (
                        <Alert
                        className=' fixed top-[5rem] z-[1000] right-[3rem] '
                            message="Error"
                            description={status.message}
                            type="error"
                            showIcon
                            closable
                        />
                    )}
                </div>

                {/* Example of a warning message - could be conditionally rendered based on app requirements */}
                <div className="mt-4">
                    {formData.message && formData.message.length > 500 && (
                        <Alert
                            message="Warning"
                            description="Your message is quite long. Consider keeping it concise for better readability."
                            type="warning"
                            showIcon
                            closable
                        />
                    )}
                </div>
            </form>
             <style jsx>{`  

             .borderColor{
              border-color:#29CC5E;
             }

             `} </style>
        </div>
    );
};

export default EmailForm;